module.exports = __webpack_public_path__ + "media/react/assets/AssessmentInfoCard-6c08047f0c58d50ebf8bfa87e96db70a.svg";